import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  standalone: true,
  imports: [CommonModule],
})
export class SpinnerComponent {
  @Input()
  height = '5rem';

  @Input()
  width = '5rem';

  @Input()
  color: string = 'var(--brand-700)';
}
